/*
  Gallery lightbox — Wurst Burger & Chili Co.
  Keyboard: Escape closes, arrows navigate. No dependencies.
*/
(function () {
  'use strict';

  function init(root) {
    var items = root.querySelectorAll('[data-wb-gal-full]');
    var lb = root.querySelector('[data-wb-lb]');
    if (!lb || !items.length) { return; }

    var img = lb.querySelector('[data-wb-lb-img]');
    var cap = lb.querySelector('[data-wb-lb-cap]');
    var current = 0;

    function show(index) {
      var count = items.length;
      current = ((index % count) + count) % count;
      var el = items[current];
      img.setAttribute('src', el.getAttribute('data-wb-gal-full'));
      var caption = el.getAttribute('data-wb-gal-cap') || '';
      img.setAttribute('alt', caption);
      cap.textContent = caption;
    }

    function open(index) {
      show(index);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      img.setAttribute('src', '');
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { open(i); });
    });

    lb.querySelector('[data-wb-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-wb-lb-prev]').addEventListener('click', function () { show(current - 1); });
    lb.querySelector('[data-wb-lb-next]').addEventListener('click', function () { show(current + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) { close(); } });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) { return; }
      if (e.key === 'Escape') { close(); }
      if (e.key === 'ArrowLeft') { show(current - 1); }
      if (e.key === 'ArrowRight') { show(current + 1); }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wb-gallery]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-wb-gallery]') : null;
    if (root) { init(root); }
  });
})();
